<template>
  <div class="row spinner-parent">
    <spinner ref="spinner" size="md" text="Loading ..." />

    <div v-if="source" class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>
            {{ source.title }}
            <open-on-site
              :source-route="source.route"
            />
            <button class="btn btn-danger btn-sm" @click="$_deleteEntity(`correspondence/${source.id}`)">
              Delete
              <span ref="deleteBtnLoader" class="btn-loader" style="display: none;" />
            </button>
          </h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label class="col-md-2">Title *</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.title"
                      type="text"
                      placeholder="Enter title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Type*</label>
                  <div class="col-md-10">
                    <select v-model="entity.type" class="form-control">
                      <option
                        v-for="entityType in corrTypesList"
                        :key="entityType"
                        :value="entityType"
                      >
                        {{ formatCorrType(entityType) }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Date</label>
                  <div class="col-md-10">
                    <datepicker
                      v-if="entity.hasOwnProperty('date')"
                      v-model="entity.date"
                      format="yyyy-MM-dd"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Receivers</label>
                  <div class="col-md-10">
                    <multiselect-remote
                      v-model="entity.receivers"
                      :default-options="defaultOptions.people"
                      :search-function="personSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Receiver location</label>
                  <div class="col-md-10">
                    <select-remote
                      v-model="entity.receiver_location"
                      :default-options="defaultOptions.locations"
                      :search-function="locationSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Senders</label>
                  <div class="col-md-10">
                    <multiselect-remote
                      v-model="entity.senders"
                      :default-options="defaultOptions.people"
                      :search-function="personSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Sender location</label>
                  <div class="col-md-10">
                    <select-remote
                      v-model="entity.sender_location"
                      :default-options="defaultOptions.locations"
                      :search-function="locationSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="body" class="col-md-2">Body</label>
                  <div class="col-md-10">
                    <ckeditor id="body" v-model="entity.body" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="summary" class="col-md-2">Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="summary" v-model="entity.summary" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="text" class="col-md-2">Text</label>
                  <div class="col-md-10">
                    <ckeditor id="text" v-model="entity.text" />
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-12">
                    <div class="form-group row">
                      <label for="body" class="col-md-2 form-control-label">PDF</label>
                      <div class="col-md-10">
                        <dropzone
                          v-if="dropzoneOptions"
                          id="files-uploader"
                          ref="dropzone"
                          :options="dropzoneOptions"
                          :destroy-dropzone="false"
                          @vdropzone-file-added="fileAdded"
                          @vdropzone-removed-file="fileRemoved"
                        />
                        <div v-else>Dropzone can't work without upload url.</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="published" class="col-md-2">Published</label>
                  <div class="col-md-10">
                    <input id="published" v-model="entity.published" type="checkbox">
                  </div>
                </div>

                <div class="form-group row">
                  <label for="featured" class="col-md-2">Featured Content</label>
                  <div class="col-md-10">
                    <select id="featured" v-model="entity.featured.section_id" class="form-control" name="featured">
                      <option v-for="(item, key) in $_featuredBlocksList" :key="item" :value="key">
                        {{ item }}
                      </option>
                    </select>
                  </div>
                </div>

                <div v-if="entity.featured.section_id && entity.featured.section_id > 0" class="form-group row">
                  <label for="bio" class="col-md-2">Featured Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="featured_body" v-model="entity.featured.featured_body" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>SEO</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">Title</label>
                  <div class="col-md-10">
                    <input
                      id="seo_title"
                      v-model="entity.seo_title"
                      type="text"
                      placeholder="Enter SEO title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Description</label>
                  <div class="col-md-10">
                    <textarea id="seo_desc" v-model="entity.seo_description" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <referencer
        :already-choosen-refs="entity.loadedReferences"
        @changeRefs="$_changeRefs"
      />

      <terms
        :already-choosen-terms="entity.terms"
        @changeTerms="$_changeTerms"
      />

      <div class="card">
        <div class="card-header">
          <strong>Path Alias</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">{{ $config.app_api.host }}</label>
                  <div class="col-md-10">
                    <input
                      id="path_alias"
                      v-model="entity.path_alias.path_alias"
                      type="text"
                      placeholder="Enter path alias"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Correspondence has updated successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
import Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.css';
import MultiselectRemote from '@/global/components/MultiselectRemote';
import SelectRemote from '@/global/components/SelectRemote';
import Referencer from '@/global/components/Referencer';
import Datepicker from '@/global/components/Datepicker';
import Terms from '@/global/components/TermsEditor';
import OpenOnSiteButton from '@/global/components/OpenOnSiteButton';
import { uploadStatus } from '@/helpers/constants';
import config from '../../../config';
// Mixins
import EditPageMixin from '@/mixins/EditPageMixin';
import DefaultOptionsRequests from '@/mixins/DefaultOptionsRequests';
import CommonPageMixin from '@/mixins/CommonPageMixin';

const { SUCCESS } = uploadStatus;

export default {
  name: 'CorrespondenceEdit',

  components: {
    'multiselect-remote': MultiselectRemote,
    'select-remote': SelectRemote,
    'open-on-site': OpenOnSiteButton,
    dropzone: Dropzone,
    referencer: Referencer,
    datepicker: Datepicker,
    terms: Terms,
  },

  mixins: [EditPageMixin, DefaultOptionsRequests, CommonPageMixin],

  data() {
    return {
      dropzoneSettings: {
        maxFiles: 1,
        maxFilesize: 100,
        acceptedFiles: 'application/pdf',
      },
      pdf: null,
      uploadedPdf: null,
    };
  },

  computed: {
    corrTypesList() {
      return this.$store.state.corrTypes.list;
    },
    dropzoneOptions() {
      return {
        headers: {
          Authorization: `Bearer ${this.$store.state.user.accessToken.access_token}`,
        },
        paramName: 'pdf',
        // url: `${this.$config.app_api.host}${this.$config.app_api.prefix}correspondence/${this.$route.params.id}/pdf`,
        url: '/',
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        autoProcessQueue: false,
        addRemoveLinks: true,
        acceptedFiles: this.dropzoneSettings.acceptedFiles,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?',
      };
    },
    uploadingFile() {
      const getUploadingStruct = this.$store.getters['uploadManager/getUploadByEntityId'];
      if (!getUploadingStruct) {
        return null;
      }
      return getUploadingStruct(this.$route.params.id, 'correspondence');
    },
  },

  watch: {
    uploadingFile: {
      handler(val) {
        if (this.uploadingFile && this.uploadingFile.status === SUCCESS) {
          this.uploadedPdf = val.file;
          this.$refs.dropzone.manuallyAddFile(val.file);
        }
      },
      deep: true,
    },
  },

  mounted() {
    this.$_getDefaultLocations();
    this.$_getDefaultPeople();
  },

  methods: {
    formatCorrType(type) {
      return type.replace(/_/g, ' ');
    },
    locationSearch: _.debounce((loading, search, vm, searchRequestId) => {
      const context = vm;
      vm.$apiHttp.get(`${vm.$config.app_api.prefix}locations?search_string=${escape(search)}`)
        .then((response) => {
          if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
          loading(false);
          const entities = response.data;
          delete entities.meta;
          context.options = Object.keys(entities).map(e => entities[e]);
        })
        .catch((error) => {
          loading(false);
          console.error(error);
        });
    }, 350),
    personSearch: _.debounce((loading, search, vm, searchRequestId) => {
      const context = vm;
      vm.$apiHttp.get(`${vm.$config.app_api.prefix}people?search_string=${escape(search)}`)
        .then((response) => {
          if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
          loading(false);
          const entities = response.data;
          delete entities.meta;
          context.options = Object.keys(entities).map(e => entities[e]);
        })
        .catch((error) => {
          loading(false);
          console.error(error);
        });
    }, 350),
    manuallyAddFiles() {
      const file = {
        file: {
          name: this.entity.pdf.file_name,
          size: this.entity.pdf.size,
        },
        url: this.entity.pdf.public_url,
        thumb: this.entity.pdf.thumbnail,
      };
      this.$refs.dropzone.manuallyAddFile(file.file, file.url);
      if (!this.entity.pdf.mime_type.match(/image.*/)) {
        $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', file.thumb);
      }
    },
    fileAdded(file) {
      this.pdf = file;
    },
    fileRemoved() {
      this.$apiHttp.delete(`${this.$config.app_api.prefix}correspondence/${this.$route.params.id}/pdf`).then(() => {
        this.pdf = null;
      }).catch((error) => {
        console.error('error in delete pdf in correspondence request - ', error);
      });
    },
    isEntityValid() {
      return this.$_validate([
        { name: 'Title', value: this.entity.title, type: 'required' },
        { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 },
        { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' },
        { name: 'Type', value: this.entity.title, type: 'required' },
      ]);
    },
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      this.$apiHttp.get(`${this.$config.app_api.prefix}correspondence/${this.$route.params.id}`, {
        params: {
          with: [
            'references',
            'pdf',
            'receiversCollection',
            'sendersCollection',
            'senderLocation',
            'receiverLocation',
            'terms',
            'path_alias',
            'featured',
          ],
        },
      })
        .then((response) => {
          this.source = this.$_apadtSource(response.data);
          this.entity = _.cloneDeep(this.source);
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          if (this.entity.pdf) {
            setTimeout(this.manuallyAddFiles, 100);
          }
        }).catch((error) => {
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          this.$store.dispatch(
            'notifications/setHttpError',
            { error, text: 'Error in getting correspondence request' },
          );
          console.error('Error in get single correspondence query', error);
        });
    },
    saveRequest() {
      const postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body ? this.entity.body : '');
      postFormData.append('text', this.entity.text ? this.entity.text : '');
      postFormData.append('date', this.entity.date ? this.entity.date : '');
      postFormData.append('type', this.entity.type);
      if (this.entity.receiver_location) postFormData.append('receiver_location', this.entity.receiver_location.id);
      if (this.entity.sender_location) postFormData.append('sender_location', this.entity.sender_location.id);
      for (let i = 0; i < this.entity.senders.length; i += 1) {
        postFormData.append('senders[]', this.entity.senders[i].id);
      }
      for (let i = 0; i < this.entity.receivers.length; i += 1) {
        postFormData.append('receivers[]', this.entity.receivers[i].id);
      }
      postFormData.append('featured', this.entity.featured.section_id ? this.entity.featured.section_id : '');
      postFormData.append('featured_body', this.entity.featured.featured_body);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}correspondence/${this.$route.params.id}`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      const { prefix, host } = this.$config.app_api;
      const token = JSON.parse(localStorage.getItem(config.tokenStorage.name));
      const vm = this;
      const { pdf } = this;
      const entityId = this.$route.params.id;
      const { acceptedFiles } = this.dropzoneOptions;
      let currFileName = this.entity.pdf ? this.entity.pdf.file_name : '';
      if (!currFileName) {
        currFileName = this.uploadedPdf ? this.uploadedPdf.name : '';
      }
      this.saveRequest().then((response) => {
        this.$_successSave();
        if (pdf && pdf.name !== currFileName) {
          this.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId,
            files: [pdf],
            token,
            acceptedFiles,
            contentType: response.data.content_type,
          });
          vm.uploadedPdf = pdf;
        }
      }).catch((error) => {
        this.$_errorSave(error);
        console.error('Error in update correspondence query', error);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Edit.vue?6bc887db